
import { Route } from '../../../core/interfaces/routes/interfaces';
import LoginPage from './login/Login';
import RegisterPage from './register/Register';




const ExternalPagesRoute: Route[] = [
    { key: undefined, path: "/login", to: "/login", name: "Login", Component: LoginPage },
    // { key: undefined, path: "/register", to: "/register", name: "Registro", Component: RegisterPage },
    // { path: "/pago/:data", to: "/pago/:data", name: "Pago", Component: PaymentPage },
    // { path: "/pago", to: "/pago", name: "Pago", Component: PaymentPage },





]

export default ExternalPagesRoute;
